import { extractDutchZipcode } from "./zipcode";
// 1790 - 1797, 8899,  8881 - 8897, 9161 - 9164 en 9166 - zipcodes op de Waddeneilanden
const excluded_zipcodes = [1790,1791,1792,1793,1794,1795,1796,1797,8899,8881,8882,8883,8884,8885,8886,8887,8888,8889,8890,8891,8892,8893,8894,8895,8896,8897,9161,9162,9163,9164,9166];

// returns true if passed zipcode is in the array of excluded zipcodes
export const invalidzipcodearea = (zipcodearea: string | undefined) => {
	if (!zipcodearea) return;
	return excluded_zipcodes.includes(extractDutchZipcode(zipcodearea))
}